import { managementSelectors, useTypedSelector } from '../../../store'
import DeviceSwitcher from './DeviceSwitcher'
import LanguageSwitcher from './LanguageSwitcher'
import Library from './Library'
import EntitySettings from './settings/EntitySettings'
import GlobalSettings from './settings/GlobalSettings'
import SettingsOverlayProvider from './settings/SettingsOverlayContext'

const Sidebar = () => {
  const editingEntityId = useTypedSelector(({ management }) =>
    managementSelectors.getEditingEntityId(management),
  )
  const isGlobalSettingsEditing = useTypedSelector(({ management }) =>
    managementSelectors.isGlobalSettingsEditing(management),
  )

  return (
    <aside className="bg-background-secondary shadow-around-sm z-sticky flex w-[400px] min-w-[400px] flex-col">
      {!editingEntityId && !isGlobalSettingsEditing && <Library />}
      {editingEntityId && (
        <SettingsOverlayProvider>
          <EntitySettings entityId={editingEntityId} />
        </SettingsOverlayProvider>
      )}
      {isGlobalSettingsEditing && (
        <SettingsOverlayProvider>
          <GlobalSettings />
        </SettingsOverlayProvider>
      )}
      <div className="border-text-secondary/30 mt-auto flex flex-col items-end border-t">
        <LanguageSwitcher />
        <DeviceSwitcher />
      </div>
    </aside>
  )
}

export default Sidebar
